/*
 * ॐ नमः शिवाय
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * Where a page-builder page lives.
 *
 * Every builder page is served under one front door, /app, so a link to one is
 * never built by hand. Three places used to write `/${slug}` themselves — the
 * nav menu, hero buttons and links inside HTML sections — and each would have
 * had to learn the prefix separately, which is exactly how one of them gets
 * missed and quietly 404s.
 *
 * Data views (/p/...) are NOT pages and do not come through here.
 */
export const APP_BASE = '/app';

/** `event-list` → `/app/event-list`. Leading slashes and blanks are tolerated. */
export function pageHref(slug) {
  const clean = String(slug || '').trim().replace(/^\/+/, '');
  return clean ? `${APP_BASE}/${clean}` : APP_BASE;
}
